import GroupMigrationContainer from '../group/containers/mx/GroupMigrationContainer';
import GroupDeleteContainer from '../group/containers/mx/GroupDeleteContainer';
import DocumentModalContainer from '../loan/common/containers/DocumentModalContainer';
import LoanMigrationContainer from '../loan/common/containers/LoanMigrationContainer';
import BankAccountContainer from '../group/containers/mx/BankAccountContainer';
import CardCommissionAccountContainer from '../group/containers/mx/CardCommissionAccountContainer';
import BankAccountDetailContainer from '../group/containers/mx/BankAccountDetailContainer';
import CardCommissionAccountDetailContainer from '../group/containers/mx/CardCommissionAccountDetailContainer';
import AttachmentDeleteContainer from '../loan/common/containers/AttachmentDeleteContainer';
import AttachmentUploadFilesContainer from '../loan/common/containers/AttachmentUploadFilesContainer';
import CreateVersionConfirmationContainer from '../loan/common/containers/CreateVersionConfirmationContainer';
import SendAttachmentsTargetContainer from '../loan/common/containers/SendAttachmentsTargetContainer';
import PipefyUpdateContainer from '../loan/common/containers/PipefyUpdateContainer';
import SendAttachmentsSuccessTargetContainer from '../loan/common/containers/SendAttachmentsSuccessTargetContainer';
import MissingLoanRequiredFieldsContainer from '../loan/common/containers/MissingLoanRequiredFieldsContainer';
import CommissionBankAccountFormContainer from '../loan/creditoReal/containers/mx/CommissionBankAccountFormContainer';
import CardCommissionDeleteContainer from '../group/containers/mx/CardCommissionDeleteContainer';
import BiometricsResetContainer from '../loan/creditoReal/containers/mx/BiometricsResetContainer';
import BiometricsDeactivateFingerprintsCaptureContainer from '../loan/creditoReal/containers/mx/BiometricsDeactivateFingerprintsCaptureContainer';
import SalesforceOpportunityCancelConfirmContainer
    from '../loan/creditoReal/containers/mx/SalesforceOpportunityCancelConfirmContainer';
import ValidationIdWaitingResponseContainer
    from '../loan/creditoReal/containers/mx/ValidationIdWaitingResponseContainer';
import ValidationIdSuccessContainer from '../loan/creditoReal/containers/mx/ValidationIdSuccessContainer';
import ValidationIdCurpContainer from '../loan/creditoReal/containers/mx/ValidationIdCurpContainer';
import ValidationIdErrorContainer from '../loan/creditoReal/containers/mx/ValidationIdErrorContainer';
import ValidationIdResetContainer from '../loan/creditoReal/containers/mx/ValidationIdResetContainer';
import ChatsShowMediaView from '../chats/components/views/modals/ChatsShowMediaView';
import ChatsUploadFilesView from '../chats/components/views/modals/ChatsUploadFilesView';
import ChatsPinChatView from '../chats/components/views/modals/ChatsPinChatView';
import ChatsAssignDocView from '../chats/components/views/modals/ChatsAssignDocView';
import MediciValidationsModalContainer from '../loan/common/containers/MediciValidationsModalContainer';
import EmailChangedModalContainer from '../loan/common/containers/EmailChangedModalContainer';
import MediciValidationsAgainModalContainer from '../loan/common/containers/MediciValidationsAgainModalContainer';
import AssemblyCountryInfoModalContainer from '../loan/common/containers/AssemblyCountryInfoModalContainer';
import LoseApplicationMotiveModalContainer from '../loan/common/containers/LoseApplicationMotiveModalContainer';
import ReopenApplicationConfirmContainer from '../loan/common/containers/ReopenApplicationConfirmContainer';
import SendToPipefyConfirmContainer from '../loan/common/containers/SendToPipefyConfirmContainer';
import ApprovedApplicationsExportConfirmContainer
    from '../approvedApplications/containers/ApprovedApplicationsExportConfirmContainer';
import ApprovedApplicationsExportVolumeView
    from '../approvedApplications/components/views/ApprovedApplicationsExportVolumeView';
import ApprovedApplicationsHistoryExportConfirmContainer
    from '../approvedApplications/containers/ApprovedApplicationsHistoryExportConfirmContainer';

export const MODAL_TYPE = {
    GROUPS_MIGRATION_CONFIRM: 'GROUPS_MIGRATION_CONFIRM',
    GROUPS_MIGRATION_SUCCESS: 'GROUPS_MIGRATION_SUCCESS',
    GROUPS_DELETE_CONFIRM: 'GROUPS_DELETE_CONFIRM',
    ATTACHMENT_DELETE_CONFIRM: 'ATTACHMENT_DELETE_CONFIRM',
    ATTACHMENT_CREATE_NEW_VERSION_CONFIRM: 'ATTACHMENT_CREATE_NEW_VERSION_CONFIRM',
    ATTACHMENT_UPLOAD_FILES: 'ATTACHMENT_UPLOAD_FILES',
    DOCUMENT_MODAL_CONTAINER: 'DOCUMENT_MODAL_CONTAINER',
    MIGRATE_GROUP_OF_LOAN_CONFIRM: 'MIGRATE_GROUP_OF_LOAN_CONFIRM',
    MIGRATE_GROUP_OF_LOAN_SUCCESS: 'MIGRATE_GROUP_OF_LOAN_SUCCESS',
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    CARD_COMMISSION_ACCOUNT: 'CARD_COMMISSION_ACCOUNT',
    BANK_ACCOUNT_DETAIL: 'BANK_ACCOUNT_DETAIL',
    CARD_COMMISSION_DETAIL: 'CARD_COMMISSION_DETAIL',
    CARD_COMMISSION_DELETE: 'CARD_COMMISSION_DELETE',
    COMMISSION_BANK_ACCOUNT: 'COMMISSION_BANK_ACCOUNT',
    PIPEFY_UPDATE_CONFIRM: 'PIPEFY_UPDATE_CONFIRM',
    SEND_ATTACHMENT_TO_TARGET: 'SEND_ATTACHMENT_TO_TARGET',
    SEND_SUCCESS_ATTACHMENT_TO_TARGET: 'SEND_SUCCESS_ATTACHMENT_TO_TARGET',
    LOAN_APPLICATION_REQUIRED_FIELDS: 'LOAN_APPLICATION_REQUIRED_FIELDS',
    BIOMETRICS_RESET_CONFIRM: 'BIOMETRICS_RESET_CONFIRM',
    BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_CONFIRM: 'BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_CONFIRM',
    SALESFORCE_CANCEL_OPPORTUNITY_CONFIRM: 'SALESFORCE_CANCEL_OPPORTUNITY_CONFIRM',
    VALIDATION_ID_WAITING_RESPONSE: 'VALIDATION_ID_WAITING_RESPONSE',
    VALIDATION_ID_SUCCESS: 'VALIDATION_ID_SUCCESS',
    VALIDATION_ID_CURP_ERROR: 'VALIDATION_ID_CURP_ERROR',
    VALIDATION_ID_ERROR: 'VALIDATION_ID_ERROR',
    VALIDATION_ID_RESET_CONFIRM: 'VALIDATION_ID_RESET_CONFIRM',
    CHATS_SHOW_MEDIA: 'CHATS_SHOW_MEDIA',
    CHATS_UPLOAD_FILES: 'CHATS_UPLOAD_FILES',
    CHATS_PIN_CHAT: 'CHATS_PIN_CHAT',
    CHATS_ASSIGN_DOC: 'CHATS_ASSIGN_DOC',
    MEDICI_VALIDATIONS_EMAIL_SENT: 'MEDICI_VALIDATIONS_EMAIL_SENT',
    MEDICI_VALIDATIONS_AGAIN_EMAIL_SENT: 'MEDICI_VALIDATIONS_AGAIN_EMAIL_SENT',
    EMAIL_CHANGED_MESSAGE: 'EMAIL_CHANGED_MESSAGE',
    ASSEMBLY_COUNTRY_INFO: 'ASSEMBLY_COUNTRY_INFO',
    LOSE_APPLICATION_MOTIVE_MODAL: 'LOSE_APPLICATION_MOTIVE_MODAL',
    REOPEN_APPLICATION_CONFIRM: 'REOPEN_APPLICATION_CONFIRM',
    SEND_TO_PIPEFY_CONFIRM: 'SEND_TO_PIPEFY_CONFIRM',
    APPROVED_APPLICATIONS_EXPORT_CONFIRM: 'APPROVED_APPLICATIONS_EXPORT_CONFIRM',
    APPROVED_APPLICATIONS_EXPORT_VOLUME: 'APPROVED_APPLICATIONS_EXPORT_VOLUME',
    APPROVED_APPLICATIONS_HISTORY_EXPORT_CONFIRM: 'APPROVED_APPLICATIONS_HISTORY_EXPORT_CONFIRM',
    APPROVED_APPLICATIONS_HISTORY_EXPORT_VOLUME: 'APPROVED_APPLICATIONS_HISTORY_EXPORT_VOLUME',
};

export const MODAL_COMPONENTS = {
    GROUPS_MIGRATION_CONFIRM: GroupMigrationContainer,
    GROUPS_MIGRATION_SUCCESS: GroupMigrationContainer,
    BIOMETRICS_RESET_CONFIRM: BiometricsResetContainer,
    BIOMETRICS_DEACTIVATE_FINGERPRINTS_CAPTURE_CONFIRM: BiometricsDeactivateFingerprintsCaptureContainer,
    SALESFORCE_CANCEL_OPPORTUNITY_CONFIRM: SalesforceOpportunityCancelConfirmContainer,
    GROUPS_DELETE_CONFIRM: GroupDeleteContainer,
    ATTACHMENT_DELETE_CONFIRM: AttachmentDeleteContainer,
    ATTACHMENT_UPLOAD_FILES: AttachmentUploadFilesContainer,
    DOCUMENT_MODAL_CONTAINER: DocumentModalContainer,
    MIGRATE_GROUP_OF_LOAN_CONFIRM: LoanMigrationContainer,
    MIGRATE_GROUP_OF_LOAN_SUCCESS: LoanMigrationContainer,
    ATTACHMENT_CREATE_NEW_VERSION_CONFIRM: CreateVersionConfirmationContainer,
    BANK_ACCOUNT: BankAccountContainer,
    CARD_COMMISSION_ACCOUNT: CardCommissionAccountContainer,
    BANK_ACCOUNT_DETAIL: BankAccountDetailContainer,
    CARD_COMMISSION_DETAIL: CardCommissionAccountDetailContainer,
    CARD_COMMISSION_DELETE: CardCommissionDeleteContainer,
    COMMISSION_BANK_ACCOUNT: CommissionBankAccountFormContainer,
    PIPEFY_UPDATE_CONFIRM: PipefyUpdateContainer,
    SEND_ATTACHMENT_TO_TARGET: SendAttachmentsTargetContainer,
    SEND_SUCCESS_ATTACHMENT_TO_TARGET: SendAttachmentsSuccessTargetContainer,
    LOAN_APPLICATION_REQUIRED_FIELDS: MissingLoanRequiredFieldsContainer,
    VALIDATION_ID_WAITING_RESPONSE: ValidationIdWaitingResponseContainer,
    VALIDATION_ID_SUCCESS: ValidationIdSuccessContainer,
    VALIDATION_ID_CURP_ERROR: ValidationIdCurpContainer,
    VALIDATION_ID_ERROR: ValidationIdErrorContainer,
    VALIDATION_ID_RESET_CONFIRM: ValidationIdResetContainer,
    CHATS_SHOW_MEDIA: ChatsShowMediaView,
    CHATS_UPLOAD_FILES: ChatsUploadFilesView,
    CHATS_PIN_CHAT: ChatsPinChatView,
    CHATS_ASSIGN_DOC: ChatsAssignDocView,
    MEDICI_VALIDATIONS_EMAIL_SENT: MediciValidationsModalContainer,
    MEDICI_VALIDATIONS_AGAIN_EMAIL_SENT: MediciValidationsAgainModalContainer,
    EMAIL_CHANGED_MESSAGE: EmailChangedModalContainer,
    ASSEMBLY_COUNTRY_INFO: AssemblyCountryInfoModalContainer,
    LOSE_APPLICATION_MOTIVE_MODAL: LoseApplicationMotiveModalContainer,
    REOPEN_APPLICATION_CONFIRM: ReopenApplicationConfirmContainer,
    SEND_TO_PIPEFY_CONFIRM: SendToPipefyConfirmContainer,
    APPROVED_APPLICATIONS_EXPORT_CONFIRM: ApprovedApplicationsExportConfirmContainer,
    APPROVED_APPLICATIONS_EXPORT_VOLUME: ApprovedApplicationsExportVolumeView,
    APPROVED_APPLICATIONS_HISTORY_EXPORT_CONFIRM: ApprovedApplicationsHistoryExportConfirmContainer,
    APPROVED_APPLICATIONS_HISTORY_EXPORT_VOLUME: ApprovedApplicationsExportVolumeView,
};
